import * as React from "react"
import Tab from "@mui/material/Tab"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import EqualizerIcon from "@mui/icons-material/Equalizer"
import TodayIcon from "@mui/icons-material/Today"
import SsidChartIcon from "@mui/icons-material/SsidChart"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import IconButton from "@mui/material/IconButton"
import SettingsIcon from "@mui/icons-material/Settings"
import Stack from "@mui/material/Stack"
import Button from "@mui/material/Button"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import Paper from "@mui/material/Paper"
import StatisticFilters from "../filters/StatisticFilters"
import StatisticHeader from "../tableComponents/tableHeader/StatisticHeader"
import InterviewsHeader from "../tableComponents/tableHeader/InterviewsHeader"
import InterviewsRow from "../tableComponents/tableRow/InterviewsRow"
import InterviewsFilter from "../filters/InterviewsFilter"
import AllTablesFilter from "../filters/AllTablesFilter"
import CustomTablePagination from "../tableComponents/tablePagination/CustomTablePagination"
import AvailableScheduleRow from "../tableComponents/tableRow/AvailableScheduleRow"
import StaststicRow from "../tableComponents/tableRow/StaststicRow"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { RootState } from "../../../../app/store"
import {
  setInterviewsPage,
  setInterwiewersPage,
  setStatisticPage,
} from "../tableComponents/tablePagination/model/pagination"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import Dialog from "@mui/material/Dialog"
import CreateInterwiew from "../create/CreateInterwiew/CreateInterwiewTabs"
import CreateInterwiewer from "../create/CreateInterwiewer/CreateInterwiewer"
import InterwiewersHeader from "../tableComponents/tableHeader/InterwiewersHeader"
import InterwiewersRow from "../tableComponents/tableRow/InterwiewersRow"
import CreateAvailableSchedule from "../create/createAvailableSchedule/CreateAvailableSchedule"
import { useGetSelectQuery } from "../../api/InterviewsApi"
import { useForm } from "react-hook-form"
import TimeSlotsHeader from "../tableComponents/tableHeader/TimeSlotsHeader"
import TimeSlotsFilter from "../filters/TimeSlotsFilter"
import TimeSlotsRow from "../tableComponents/tableRow/TimeSlotsRow"
import AvailableScheduleHeader from "../tableComponents/tableHeader/AvailableScheduleHeader"
import AvailableScheduleFilter from "../filters/AvailableScheduleFilter"
import { IСreateAvailableSchedule } from "../../model/create/СreateAvailableSchedule"
import DropoutRate from "../dropoutRate/DropoutRate"
import CreateTimeSlots from "../create/createTimeSlots/CreateTimeSlots"
import CustomTableWeekPagination from "../tableComponents/tablePagination/CustomTableWeekPagination"
import CRUDTimeSlotsDialog from "../create/dialogs/CRUDTimeSlotsDialog"
import InterviewsDialog from "../create/dialogs/InterviewsDialog"
import {
  IInterviewDate,
  IInterviewFullRow,
  setInterviewDateState,
  setInterviewModeState,
  setInterviewRowState,
} from "../create/dialogs/model/Interviews"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { keycloakInstance } from "../../../../shared/libs/keycloack/config"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import TabContext from "@mui/lab/TabContext"
import { Popover, Tooltip } from "@mui/material"
import WeekStaststicRow from "../tableComponents/tableRow/WeekStaststicRow"

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import WeekStatisticFilter from "../filters/WeekStatisticFilter"
import { TimeSlotsCandidatesDialog } from "../create/dialogs/TimeSlotsCandidatesDialog"
import WeekStatisticDialog from "../create/dialogs/WeekStatisticDialog"
import { useSearchParams } from "react-router-dom"

interface TabInfo {
  value: string
  title: string
  icon: React.ReactNode
  filter: React.ReactNode
  tableHeader: React.ReactNode
  TableRow: React.ReactNode
  tableFooter: React.ReactNode
  scrollable: boolean
  disabled: boolean
  access: string[]
}

const AllTabPanel = () => {
  const [value, setValue] = React.useState("0")
  const [statisticValue, setStatisticValue] = React.useState("0")
  const selects = useGetSelectQuery()

  const [searchParams, setSearchParams] = useSearchParams()
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSearchParams({})

    setValue(newValue)

    if (statisticValue !== "0") {
      setStatisticValue("0")
    }
  }

  const [open, setOpen] = React.useState({
    openInterviewer: false,
    openCreateInterwiew: false,
    // openCreateAvailableSchedule: { open: false, type: "edit" || "add" },
    openCreateAvailableSchedule: { open: false, type: "" },
    openTimeSlots: false,
    // openCRUDTimeSlots: { open: false, type: "edit" || "add" || 'info'},
    openCRUDTimeSlots: { open: false, type: "" },
    // type: edit | info
    openInterviewsDialog: false,
    weekStatisticDialog: false,
  })

  const [openTooltip, setOpenTooltip] = React.useState(false)

  const handleCloseTooltip = () => {
    setOpenTooltip(false)
  }

  const handleOpenTooltip = () => {
    setOpenTooltip(true)
  }

  const [editRow, setEditRow] = React.useState({
    graphType: { id: null, name: null },
    schedule: {
      pattern: { id: null, name: null },
      startDate: null,
      endDate: null,
    },
    isDeletable: null,
    isEditable: null,
    project: { id: null, name: null },
    workDays: {
      startDate: null,
      endDate: null,
    },
    department: { id: null, name: null },
    line: { id: null, name: null },
    dropoutRate: null,

    scheduleQuantity: null,
    requirement: {
      startDate: null,
      endDate: null,
      status: null,
    },
    activeSchedule: null,
  })

  const { reset } = useForm<IСreateAvailableSchedule>({
    defaultValues: editRow,
  })

  const pagination = useSelector((state: RootState) => state.pagination)
  const weekPagination = useSelector((state: RootState) => state.weekPagination)

  const [edit, setEdit] = React.useState(false)

  const dispatch = useDispatch()

  const handleClose = () => {
    setAnchorEl(null)
  }

  const tabs: TabInfo[] = [
    {
      value: "0",
      title: "Назначенные собеседования",
      icon: <TodayIcon />,
      filter: <InterviewsFilter />,
      tableHeader: <InterviewsHeader />,
      TableRow: <InterviewsRow open={open} setOpen={setOpen} />,
      tableFooter: (
        <CustomTablePagination
          page={pagination.InterviewsPage}
          totalPages={pagination.InterviewsTotalPages}
          totalItems={pagination.InterviewsTotalItems}
          setPage={setInterviewsPage}
        />
      ),
      scrollable: false,
      disabled: false,
      access: [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-recruiter",
        "hiring-training",
        "hiring-viewer",
      ],
    },

    {
      value: "1",
      title: "Слоты времени",
      icon: <AccessTimeIcon />,
      filter: (
        <TimeSlotsFilter open={open} setOpen={setOpen} selects={selects} />
      ),
      tableHeader: <TimeSlotsHeader />,
      TableRow: <TimeSlotsRow open={open} setOpen={setOpen} />,
      tableFooter: (
        <CustomTableWeekPagination weekPagination={weekPagination} />
      ),
      scrollable: false,
      disabled: false,
      access: [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-recruiter",
        "hiring-viewer",
      ],
    },

    {
      value: "2",
      title: "Графики в наборе",
      icon: <SsidChartIcon />,
      // filter: <AvailableScheduleFilter />,
      filter: <StatisticFilters open={open} setOpen={setOpen} />,
      tableHeader: <AvailableScheduleHeader />,
      TableRow: (
        <AvailableScheduleRow
          setEditRow={setEditRow}
          setOpen={setOpen}
          open={open}
        />
      ),
      tableFooter: (
        <Stack sx={{ pb: "16px", mt: "8px" }} width="100%">
          {keycloakInstance.realmAccess?.roles.some((role) =>
            ["hiring-admin"].includes(role),
          ) && (
            <Button
              sx={{
                height: "30px",
                fontSize: "16px",
                fontWeight: "700",
              }}
              fullWidth
              variant="contained"
              onClick={() => {
                reset({})
                setEditRow({
                  graphType: { id: null, name: null },
                  schedule: {
                    pattern: { id: null, name: null },
                    startDate: null,
                    endDate: null,
                  },
                  workDays: {
                    startDate: null,
                    endDate: null,
                  },
                  isDeletable: null,
                  isEditable: null,
                  project: { id: null, name: null },
                  department: { id: null, name: null },
                  line: { id: null, name: null },
                  dropoutRate: null,

                  scheduleQuantity: null,
                  requirement: {
                    startDate: null,
                    endDate: null,
                    status: null,
                  },
                  activeSchedule: null,
                })

                setOpen({
                  ...open,
                  openCreateAvailableSchedule: { open: true, type: "add" },
                })
              }}
            >
              Добавить график
            </Button>
          )}
        </Stack>
      ),
      scrollable: true,
      disabled: false,

      access: [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-recruiter",
        "hiring-training",
        "hiring-viewer",
      ],
    },

    // {
    //   // value: "3" || "6",
    //   // value: "3",
    //   // title: "Статистика",
    //   // icon: <EqualizerIcon />,
    //   // filter:
    //   //   statisticValue === "0" ? (
    //   //     <StatisticFilters open={open} setOpen={setOpen} />
    //   //   ) : (
    //   //     <WeekStatisticFilter statisticValue={statisticValue} />
    //   //   ),
    //   // tableHeader: <StatisticHeader />,
    //   // TableRow: <StaststicRow />,
    //   // tableFooter: (
    //   //   <CustomTablePagination
    //   //     page={pagination.StatisticPage}
    //   //     totalPages={pagination.StatisticTotalPages}
    //   //     setPage={setStatisticPage}
    //   //   />
    //   // ),
    //   // scrollable: true,
    //   // disabled: false,
    //   // access: [
    //   //   "hiring-admin",
    //   //   "hiring-interviewer",
    //   //   "hiring-recruiter",
    //   //   "hiring-training",
    //   //   "hiring-viewer",
    //   // ],
    // },
    {
      value: "4",
      title: "Собеседующие",
      icon: <EqualizerIcon />,
      filter: <></>,
      // keycloakInstance.realmAccess?.roles.some((role) =>
      //   ["hiring-admin"].includes(role),
      // ) ? (
      //   <Button
      //     startIcon={<AddCircleOutlineIcon />}
      //     onClick={() => setOpen({ ...open, openInterviewer: true })}
      //   >
      //     Добавить собеседующего
      //   </Button>
      // ) : (
      //   <></>
      // ),
      tableHeader: <InterwiewersHeader />,
      TableRow: <InterwiewersRow open={open} setOpen={setOpen} />,
      tableFooter: (
        <CustomTablePagination
          page={pagination.InterwiewersPage}
          totalPages={pagination.InterwiewersTotalPages}
          setPage={setInterwiewersPage}
        />
      ),
      scrollable: false,
      disabled: false,
      access: [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-recruiter",
        "hiring-training",
        "hiring-viewer",
      ],
    },
    {
      value: "5",
      title: "Процент отсева",
      icon: <EqualizerIcon />,
      filter: null,
      tableHeader: null,
      TableRow: null,
      tableFooter: null,
      scrollable: false,
      disabled: false,
      access: [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-recruiter",
        "hiring-training",
        "hiring-viewer",
      ],
    },
    {
      value: "6" || "3",
      title: "Статистика по неделям",
      icon: null,
      filter: <></>,
      tableHeader: null,
      TableRow: null,
      tableFooter: null,
      scrollable: true,
      disabled: false,
      access: [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-recruiter",
        "hiring-training",
        "hiring-viewer",
      ],
    },
  ]

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClickPopover = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const openPopover = Boolean(anchorEl)
  const id = open ? "simple-popper" : undefined

  return (
    <TabContext value={value}>
      <Stack
        sx={{
          bgcolor: "background.paper",
          px: "22px",
          py: "15px",
          borderRadius: "4px",
        }}
        justifyContent="space-between"
        alignItems="center"
        direction="row"
      >
        <Stack alignItems="center" direction="row" spacing="8px">
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            {tabs
              .filter((tab) =>
                tab.access.some((role) =>
                  keycloakInstance.realmAccess?.roles?.includes(role),
                ),
              )
              .filter(
                (tab) =>
                  tab.value !== "4" && tab.value !== "5" && tab.value !== "6",
              )
              .map((tab) => {
                return (
                  <Tab
                    value={tab.value}
                    key={tab.value}
                    disabled={tab.disabled}
                    iconPosition="start"
                    label={
                      <Typography
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "6px",
                          textTransform: "none",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        {tab.icon} {tab.title}
                      </Typography>
                    }
                    // label={
                    //   tab.value === "3" ? (
                    //     <Tooltip
                    //       disableFocusListener
                    //       open={openTooltip}
                    //       onClose={handleCloseTooltip}
                    //       onOpen={handleOpenTooltip}
                    //       componentsProps={{
                    //         tooltip: {
                    //           sx: {
                    //             borderTop: "3px solid #1B9C18",
                    //             borderLeft: "none",
                    //             borderRight: "none",
                    //             borderBottom: "none",
                    //             backgroundColor: "#DDEADC",

                    //             "& .MuiTooltip-arrow": {
                    //               color: "common.black",
                    //             },
                    //           },
                    //         },
                    //       }}
                    //       title={
                    //         <Stack
                    //           onMouseEnter={handleOpenTooltip}
                    //           direction="column"
                    //           sx={{ p: 0, m: 0 }}
                    //         >
                    //           <Button
                    //             onMouseEnter={handleOpenTooltip}
                    //             sx={{
                    //               color: "#000000",
                    //               fontWeight: "500",
                    //               fontSize: "14px",
                    //             }}
                    //             onClick={() => {
                    //               setValue("3")
                    //               setStatisticValue("0")
                    //             }}
                    //           >
                    //             Статистика по графикам
                    //           </Button>
                    //           <Button
                    //             onMouseEnter={handleOpenTooltip}
                    //             disabled
                    //             sx={{
                    //               color: "#000000",
                    //               fontWeight: "500",
                    //               fontSize: "14px",
                    //             }}
                    //             onClick={() => {
                    //               setValue("3")
                    //               setStatisticValue("1")
                    //             }}
                    //           >
                    //             Статистика по неделям
                    //           </Button>
                    //         </Stack>
                    //       }
                    //     >
                    //       <Typography
                    //         onMouseEnter={handleOpenTooltip}
                    //         sx={{
                    //           display: "flex",
                    //           justifyContent: "center",
                    //           alignItems: "center",
                    //           gap: "6px",
                    //           textTransform: "none",
                    //           fontWeight: "500",
                    //           fontSize: "14px",
                    //         }}
                    //       >
                    //         {tab.icon} {tab.title}{" "}
                    //         {openTooltip ? (
                    //           <KeyboardArrowUpIcon />
                    //         ) : (
                    //           <KeyboardArrowDownIcon />
                    //         )}
                    //       </Typography>
                    //     </Tooltip>
                    //   ) : (
                    //     <Typography
                    //       sx={{
                    //         display: "flex",
                    //         justifyContent: "center",
                    //         alignItems: "center",
                    //         gap: "6px",
                    //         textTransform: "none",
                    //         fontWeight: "500",
                    //         fontSize: "14px",
                    //       }}
                    //     >
                    //       {tab.icon} {tab.title}
                    //     </Typography>
                    //   )
                    // }
                  />
                )
              })}
          </TabList>

          <IconButton
            onClick={(event) => {
              handleClickPopover(event || ({} as React.MouseEvent<HTMLElement>))
            }}
            aria-label="add an alarm"
            sx={{
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            {keycloakInstance.realmAccess?.roles.some((role) =>
              [
                "hiring-admin",
                "hiring-interviewer",
                "hiring-viewer",
                "hiring-recruiter",
              ].includes(role),
            ) && <SettingsIcon />}
          </IconButton>
        </Stack>
        {keycloakInstance.realmAccess?.roles.some((role) =>
          [
            "hiring-admin",
            "hiring-interviewer",
            "hiring-recruiter",
            "hiring-training",
          ].includes(role),
        ) && (
          <Button
            sx={{ width: "272px", fontSize: 16, fontWeight: "bold" }}
            variant="contained"
            onClick={() => {
              dispatch(setInterviewRowState({} as IInterviewFullRow))
              setOpen({ ...open, openCreateInterwiew: true })
              dispatch(setInterviewModeState({ mode: "create" }))
              dispatch(setInterviewDateState({} as IInterviewDate))
            }}
          >
            Назначить собеседование
          </Button>
        )}
      </Stack>
      <Box
        sx={{ bgcolor: "background.paper", mt: "10px", borderRadius: "4px" }}
      >
        {tabs
          .filter((tab) =>
            tab.access.some((role) =>
              keycloakInstance.realmAccess?.roles?.includes(role),
            ),
          )
          .map((tab) => (
            <TabPanel key={tab.value} value={tab.value}>
              <Stack
                direction={"row"}
                alignItems="center"
                justifyContent={"space-between"}
              >
                {tab.value !== "5" &&
                tab.value !== "1" &&
                tab.value !== "6" &&
                tab.value !== "3" ? (
                  <AllTablesFilter
                    withProjectFilter={tab.value === "3"}
                    withoutFilter={
                      tab.value === "3" ||
                      tab.value === "2" ||
                      tab.value === "1" ||
                      tab.value === "4"
                    }
                  />
                ) : (
                  <></>
                )}
                {tab.filter}
              </Stack>
              <Box sx={{ maxWidth: "1232px", borderRadius: "4px" }}>
                {tab.value !== "5" &&
                tab.value !== "6" &&
                statisticValue !== "1" ? (
                  <TableContainer
                    sx={{
                      mt: "20px",
                      border: (theme) =>
                        theme.palette.mode === "dark"
                          ? "1px solid rgba(242, 242, 242, 0.2)"
                          : "1px solid rgba(23, 23, 23, 0.2)",
                      px: "10px",
                      maxHeight: "63.9vh",
                      minHeight: "63.9vh",
                      bgcolor: "background.paper",
                    }}
                    elevation={0}
                    component={Paper}
                  >
                    <Table
                      sx={{
                        overflow: "scroll",
                        borderCollapse: "separate",
                        borderSpacing: "0px 10px",
                        height: "62vh",
                        display: tab.scrollable ? "table-row-group" : "table",
                        ".MuiTableCell-root ": {
                          borderBottom:
                            tab.value === "1"
                              ? "1px solid rgba(230, 230, 230, 1)"
                              : "",
                        },
                      }}
                      aria-label="table"
                      stickyHeader
                    >
                      <TableHead
                        sx={{
                          bgcolor: (theme) =>
                            theme.palette.mode === "dark"
                              ? "rgb(55, 55, 55)"
                              : "rgba(225, 225, 225, 1)",
                        }}
                      >
                        {tab.tableHeader}
                      </TableHead>
                      <TableBody
                        sx={{
                          overflow: "scroll",
                          maxHeight: "700px",
                        }}
                      >
                        {tab.TableRow}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  tab.value !== "6" &&
                  statisticValue !== "1" && (
                    <DropoutRate edit={edit} setEdit={setEdit} />
                  )
                )}
                {statisticValue === "1" && (
                  <WeekStaststicRow></WeekStaststicRow>
                )}
              </Box>

              {tab.tableFooter}
            </TabPanel>
          ))}
      </Box>
      {open.openCreateInterwiew && (
        <CreateInterwiew selects={selects} open={open} setOpen={setOpen} />
      )}
      {open.weekStatisticDialog && (
        <WeekStatisticDialog selects={selects} open={open} setOpen={setOpen} />
      )}
      <Dialog
        maxWidth={"xl"}
        open={open.openInterviewer}
        keepMounted
        onClose={() => setOpen({ ...open, openInterviewer: false })}
        aria-describedby="alert-dialog-slide-description"
      >
        <Box sx={{ px: "28px", py: "14px" }}>
          <DialogTitle sx={{ fontWeight: "bold" }}>
            {"Редактирование собеседующего"}
          </DialogTitle>
          <DialogContent>
            {open.openInterviewer && (
              <CreateInterwiewer open={open} setOpen={setOpen} />
            )}
          </DialogContent>
        </Box>
      </Dialog>

      {open.openCreateAvailableSchedule.open &&
        open.openCreateAvailableSchedule.type !== "info" && (
          <CreateAvailableSchedule
            editRow={editRow}
            selects={selects.data}
            open={open}
            setOpen={setOpen}
            setEditRow={setEditRow}
          />
        )}
      {open.openCRUDTimeSlots.open &&
        open.openCRUDTimeSlots.type !== "info" && (
          <CRUDTimeSlotsDialog open={open} setOpen={setOpen} />
        )}
      {open.openCRUDTimeSlots.open &&
        open.openCRUDTimeSlots.type === "info" && (
          <TimeSlotsCandidatesDialog open={open} setOpen={setOpen} />
        )}
      {(open.openInterviewsDialog || open.openCreateInterwiew) && (
        <InterviewsDialog open={open} setOpen={setOpen} />
      )}
      {open.openCreateAvailableSchedule.open &&
        open.openCreateAvailableSchedule.type === "info" && (
          <TimeSlotsCandidatesDialog open={open} setOpen={setOpen} />
        )}

      <CreateTimeSlots open={open} setOpen={setOpen} />

      <Popover
        onClose={handleClose}
        id={id}
        open={openPopover}
        anchorEl={anchorEl}
        sx={{ ".MuiPopover-paper": { boxShadow: "none" } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Stack
          sx={{
            border: "1px solid rgba(27, 156, 24, 1)",
            borderRadius: "4px",
            p: 1,
            bgcolor: "background.paper",
          }}
          direction={"column"}
          spacing={1}
        >
          {keycloakInstance.realmAccess?.roles.some((role) =>
            [
              "hiring-admin",
              "hiring-interviewer",
              "hiring-viewer",
              "hiring-recruiter",
            ].includes(role),
          ) && (
            <Button
              onClick={(event) => {
                handleClickPopover(
                  event || ({} as React.MouseEvent<HTMLElement>),
                )
                setValue("4")
              }}
              variant="outlined"
            >
              Собеседующие
            </Button>
          )}

          {keycloakInstance.realmAccess?.roles.some((role) =>
            ["hiring-admin", "hiring-interviewer", "hiring-viewer"].includes(
              role,
            ),
          ) && (
            <Button
              onClick={(event) => {
                handleClickPopover(
                  event || ({} as React.MouseEvent<HTMLElement>),
                )
                setValue("5")
              }}
              variant="outlined"
            >
              Процент отсева
            </Button>
          )}
        </Stack>
      </Popover>
    </TabContext>
  )
}

export default AllTabPanel
